export default class sl {
  static translations = {
    views: {
      notFound: {
        pageNotFound: 'Stran ni najdena.',
      },
      browserNotSupported: {
        message: 'Vaš brskalnik ni podprt.',
      },
    },
    helpers: {
      handle_session_error: {
        loggedOutPrompt: {
          title: 'Ste se prijavili na drugi napravi?',
          message:
            'Iz te naprave ste odjavljeni, ker ste do sistema dostopali prek druge naprave. Si to bil ti?',
        },
        loggedOutAlert: {
          message: 'Vaša prijava je bila uspešno oddana.',
        },
      },
    },
    components: {
      login: {
        switchDevicePrompt: {
          title: 'Prijavite se tukaj?',
          message:
            'Ste že prijavljeni v drug brskalnik. Ali ste prepričani, da se želite odjaviti iz drugega brskalnika in dostopati prek tega?',
        },
      },
      documentRename: {
        headline: 'Preimenujte datoteko',
      },
      eventTabDocuments: {
        status: 'Stanje',
        private: 'Zasebno',
        public: 'Javno',
      },
      eventTabQuestionsAndStatistics: {
        questions: 'Glasovanje',
        statistics: 'Statistika',
        noQuestionSelected:
          'V času volitev si boste tukaj lahko ogledali tudi izide volitev oziroma seznam udeležencev. Ob koncu volitev vam bodo na voljo rezultati in seznam udeležencev ter njihovih aktivnosti.',
        errors: {
          questionNotFound: 'Vprašanja ni bilo najdeno na seznamu vprašanj.',
        },
      },
      eventTabVotersAndCommunication: {
        voters: 'Udeleženci',
        communicationEmpty:
          'Ako ste odabrali opciju postavljanja pitanja sudionicima ili postavljanja pitanja sudionicima na početku događaja, ovdje ćete moći pogledati i moderirati sva pitanja.',
        live: 'V živo',
        archive: 'Arhivi',
        questions: 'vprašanja',
      },
      messageList: {
        displayMessage: 'Prikaži vprašanja',
      },
      authorizerCreate: {
        validation: {
          name: {
            required: 'Potrebno je vnesti ime.',
            length: 'Ime je lahko dolgo do 191 znakov.',
            unique: 'Ime mora biti edinstveno.',
          },
        },
      },
      authorizerEdit: {
        validation: {
          name: {
            required: 'Potrebno je vnesti ime.',
            length: 'Ime je lahko dolgo do 191 znakov.',
            unique: 'Ime mora biti edinstveno.',
          },
        },
      },
      questionCreate: {
        newQuestion: 'Novi sklep/točka',
        validation: {
          quorum: {
            integer: 'Vrednost mora biti celo število.',
            min: 'Najmanjša vrednost je 1.',
          },
          question: {
            required: 'Potrebno je vnesti vprašanje.',
            length: 'Vprašanje ima lahko največ 2000 znakov.',
          },
          answers: {
            min: 'Vnesti morate vsaj dva odgovora.',
            required: 'Vnesti morate odgovor.',
          },
          minChoices: {
            min: 'Najmanjša vrednost je 1.',
            length: 'Število odgovorov je manjše ali enako vneseni vrednosti.',
          },
          maxChoices: {
            min: 'Najmanjša vrednost je 0.',
            length: 'Število odgovorov je manjše od vnesene vrednosti.',
          },
        },
      },
      questionEdit: {
        editQuestion: 'Uredi izbor',
        validation: {
          question: {
            required: 'PPotrebno je vnesti vprašanje.',
            length: 'Vprašanje ima lahko največ 2000 znakov.',
          },
          answers: {
            min: 'Vnesti morate vsaj dva odgovora.',
            required: 'Vnesti morate odgovor.',
          },
          minChoices: {
            min: 'Najmanjša vrednost je 1.',
            length: 'Število odgovorov je manjše ali enako vneseni vrednosti.',
          },
          maxChoices: {
            min: 'Najmanjša vrednost je 0.',
            length: 'Število odgovorov je manjše od vnesene vrednosti.',
          },
        },
      },
      authorizerList: {
        errors: {
          authorizerNotFound:
            'Zastopnik ni bilo mogoče najti na seznamu zastopnika.',
        },
      },
      questionList: {
        started: 'Aktivno',
        stopped: 'Ustavil se',
        draft: 'Skica',
        startedText: 'Izbira se je začela v {value}',
        stoppedText: 'Trajanje od {od} do {do}',
        verify: {
          startQuestion: 'Ali ste prepričani, da želite začeti glasovanje?',
          stopQuestion: 'Ali ste prepričani, da želite ustaviti glasovanje?',
        },
        errors: {
          questionNotFound: 'Vprašanja ni bilo najdeno na seznamu vprašanj.',
        },
      },
      questionStatistics: {
        totalActiveVoters: 'Skupno število aktivnih udeležencev:',
        quorumRequired: 'Potreben je sklepčnost:',
        theseAreTheResults: 'To so rezultati glasovanja.',
        totalVotes: 'Skupno število glasov:',
        noResults: 'Ni rezultatov. Nihče ni glasoval.',
        refreshResults: 'Osveži rezultate',
        voters: 'Udeleženci',
        abstentioned: 'Zadržan',
        notStarted: 'Volitve se ni začela in ni rezultatov.',
      },
    },
    loginScreen: {
      login: 'Registracija',
      register: 'Registracija',
      forgotPassword: 'Ste pozabili geslo?',
      reset: 'Ponastavite geslo',
      back: 'Nazaj',
      switchToEnglish: 'Preklopite na angleščino',
      switchToCroatian: 'Preklopi na hrvaščino',
      tfaDescription:
        'PIN za autentifikaciju poslan je SMS-om na vaš mobilni telefon. Unesite ga za nastavak.',
      check: 'Preveri',
    },
    footer: {
      userManual: 'Navodila za uporabo',
      support: 'Podpora',
    },
    toolbar: {
      logout: 'Odjava',
    },
    resultsLabels: {
      votingResults: 'Rezultati glasovanja',
      votingDetails: 'Podrobnosti glasovanja',
      currentVotingStatus: 'Trenutni status glasovanja',
      notEnough:
        'Za prikaz rezultatov glasovanja je potrebnih najmanj 10 glasov.',
      initial_email_fail_hard:
        'Povabil na glasovanje ni bilo mogoče dostaviti (težko)',
      initial_email_fail_soft:
        'Povabil na glasovanje ni bilo mogoče dostaviti (mehko)',
      initial_email_delivered:
        'Dostavljena vabila k glasovanju po elektronski pošti',
      initial_email_sent: 'Povabila poslana volivcem',
      initial_email_read: 'Vabila prebrana',
      vote_link_opened: 'Udeleženci, ki so odprli povezavo za glasovanje',
      sms_sent: 'Udeleženci, ki so zahtevali PIN preko SMS-a',
      sms_recieved: 'Udeleženci, ki so prejeli PIN preko SMS-a',
      pin_checked_true: 'Udeleženci, ki so vnesli pravilen PIN',
      pin_checked_false: 'Udeleženci, ki so vnesli napačno kodo PIN',
      voted: 'Udeleženci, ki so glasovali',
      sms_rejected: 'Udeleženci, katerih SMS je bil pokvarjen',
      active_voters: 'Aktivno število volivcev',
    },
    titles: {
      results: 'Rezultati',
    },
    fields: {
      authorizers: 'Pooblaščenci',
      event_quorum_value: 'Vrednost',
      search: 'Išči',
      name: 'Ime',
      name_and_surname: 'Ime in priimek',
      event_name: 'Notranje ime dogodka',
      surname: 'Priimek',
      email: 'E-naslov',
      mobile: 'Telefonska številka',
      password: 'Geslo',
      start: 'Začetek',
      end: 'Konec',
      start_date: 'Datum začetka dogodka',
      end_date: 'Končni datum dogodka',
      start_time: 'Čas začetka dogodka',
      end_time: 'Končni čas dogodka',
      status: 'Stanje',
      option: 'Možnost',
      addOption: 'Vnesite podani odgovor ali ga pustite prazno',
      new_option: 'Nova možnost',
      voters: 'Volivci',
      header: 'Glava glasovnice',
      footer: 'Spodnji del glasovnice',
      intro: 'Uvod',
      introTitle: 'Naslov e-poštnega povabila udeležencem',
      intro_text: 'Vsebina e-poštnega vabila udeležencem (prosti vnos)',
      reminder_title: 'Naslov',
      reminder_text: 'E-mail opomnik',
      help_contact: 'E-poštna podpora',
      question: 'Vprašanje',
      event_title: 'Ime dogodka',
      time: 'Čas',
      step: 'Korak',
      maximum_choices: 'Največje število možnih odgovorov',
      minimum_choices: 'Najmanjše število možnih odgovorov',
      old_password: 'Staro geslo',
      new_password_1: 'Novo geslo',
      new_password_2: 'Ponovite novo geslo',
      eventTags: 'Notranje oznake za kategorizacijo dogodkov',
      tags: 'Notranje oznake',
      event: 'Dogodki',
      phone: 'Telefon',
      subject: 'Naslov',
      message: 'Sporočilo',
      clientName: 'Ime',
      address: 'Naslov',
      city: 'Mesto',
      country: 'Država',
      oib: 'OIB',
      contact_person: 'Kontaktna oseba',
      contact_email: 'Kontaktna e-pošta',
      allowed_domains: 'Dovoljene domene',
      eventType: 'Vrsta glasovanja',
      weight: 'Utež',
      tokensPro: 'Žetonov',
      tokens2fa: '2fa žetonov',
      pin: 'PIN',
      tfaEnabled: 'Vklopljeno',
      voted: 'Glasoval',
      authorizer: 'Pooblaščenec',
    },
    tabs: {
      general: 'Osnovni podatki',
      ballot: 'Udeleženci',
      communication: 'Komunikacija',
      results: 'Rezultati',
      log: 'Zapisi dejavnosti',
      voters: 'Glasovanje in statistika',
      messages: 'Vabila',
      emailInvitation: 'E-poštno povabilo',
      emailReminder: 'E-poštni opomnik',
      emailSupport: 'Podpora volivcem',
      options: 'Dokumenti',
      publish: 'Objavi',
      test: 'Dnevni red',
    },
    modules: {
      dashboard: 'Prednja stran',
      voterGroups: 'Skupina volivcev',
      events: 'Dogodki',
      event: 'Dogodek',
      settings: 'Nastavitve',
      upgrade: 'Nadgradite svoj račun',
      newEvent: 'Nov dogodek',
    },
    dataTable: {
      rowsPerPage: 'Vrstice na stran:',
      results: 'Rezultati',
      of: 'od',
      search: 'Išči',
      all: 'Vse',
    },
    alerts: {
      eventTypeTransparent: 'Z izbiro te možnosti glasovanje ne bo anonimno.',
      quorumValueEmpty: 'Vnesti morate vrednost kvoruma.',
      quorumValueNotInteger: 'Vrednost kvoruma mora biti celo število',
      quorumValueMin: 'Najmanjša vrednost kvoruma je 1.',
      maxFileSizeLimit: 'Ne morete vnesti več kot 8 MB na datoteko.',
      refreshPage: 'Osveži stran?',
      closeQuestionCreate:
        'Ali ste prepričani, da želite zapustiti ustvarjanje izbora brez shranjevanja?',
      startEvent:
        'Ali ste prepričani, da želite voditi ta dogodek? Ko se dogodek enkrat zažene, je mogoče le ustaviti, ne pa ga znova zagnati.',
      stopEvent:
        'Ali ste prepričani, da želite ustaviti ta dogodek? Ko je dogodek ustavljen, ga je mogoče samo ustaviti, ne pa ga znova zagnati.',
      resendSingleQuestion: 'Ali želite volivcu poslati elektronsko sporočilo?',
      resendQuestion:
        'Ali ste prepričani, da želite ponovno poslati e-pošto volivcu?',
      optionDeletionQuestion:
        'Ali ste prepričani, da želite izbrisati to možnost?',
      questionDeletionQuestion:
        'Ali ste prepričani, da želite izbrisati to vprašanje?',
      voterDeletionQuestion:
        'Ali ste prepričani, da želite izbrisati tega volivca?',
      deletionQuestion: 'Ali ste prepričani, da želite izbrisati ta zapis?',
      deletionQuestionAdditional:
        'Ali ste prepričani, da želite izbrisati ta zapis?',
      cloneQuestion: 'Ali ste prepričani, da želite podvojiti ta zapis?',
      archiveQuestion: 'Ali ste prepričani, da želite arhivirati ta zapis?',
      nameMissing: 'Niste vnesli imena dogodka.',
      firstnameMissing: 'Niste vnesli imena.',
      nameTooLong: 'Ime ne sme biti daljše od 40 znakov.',
      reminderTitleTooLong: 'Naslov ne sme biti daljše od 50 znakov.',
      nameLength: 'Ime mora biti dolgo vsaj dva znaka.',
      surnameMissing: 'Niste vnesli priimka.',
      surnameLength: 'Priimek mora vsebovati vsaj dva znaka.',
      mobileMissing: 'Niste vnesli številke mobilnega telefona.',
      mobileFailFormat: 'Številka mobilnega telefona je v napačni obliki.',
      phoneMissing: 'Niste vnesli telefonske številke.',
      phoneFailFormat: 'Telefonska številka je v napačni obliki.',
      emailMissing: 'Niste vnesli e-pošte.',
      emailVerification: 'E-pošta ni veljavna.',
      email1Verification: 'E-pošta 1 ni veljavna.',
      email2Verification: 'E-pošta 2 ni veljavna.',
      email3Verification: 'E-pošta 3 ni veljavna.',
      emailDomain: 'E-poštna domena ni odobrena.',
      passwordMissing: 'Niste vnesli gesla.',
      passwordSpaces: 'Geslo ne sme vsebovati presledkov.',
      startDateMissing: 'Niste izbrali začetnega datuma.',
      startTimeMissing: 'Niste izbrali začetnega časa.',
      startTimeVerification: 'Začetni čas ni veljaven',
      endDateMissing: 'Niste izbrali končnega datuma.',
      endTimeMissing: 'Niste izbrali končnega časa.',
      endTimeVerification: 'Končni čas ni veljaven.',
      helpContactMissing: 'Niste vnesli e-pošte za podporo volivcem.',
      helpContactFormat: 'E-poštni naslov za podporo ni pravilen.',
      votersMissing: 'Niste izbirali volivcev.',
      questionsMissing: 'Niste vnesli nobenega vprašanja.',
      questionsDuplicate: 'Dvakrat ste vnesli vprašanje.',
      questionEmpty: 'Imate vprašanje brez besedila.',
      optionsDuplicate: 'V enem vprašanju ste dvakrat vnesli isto možnost.',
      optionEmpty: 'Obstaja odgovor, ki je prazen.',
      notEnoughOptions: 'Vsako vprašanje mora imeti vsaj dve možnosti.',
      tooManyOptionsMax:
        'Postoji problem u kojem je broj opcija manji od maksimalnog broja izbora.',
      tooManyOptionsMin:
        'Postoji problem u kojem je broj opcija manji ili jednak minimalnom broju izbora.',
      maxZero: 'Največje število izbir ne sme biti nič.',
      minZero: 'Najmanjše število izbir ne sme biti nič.',
      headerMissing: 'Niste vnesli glave.',
      footerMissing: 'Niste vnesli noge.',
      introMailMissing:
        'Niste vnesli vsebine elektronske pošte z vabilom na glasovanje.',
      introMailTitleMissing:
        'Niste vnesli e-poštnega naslova za povabilo k glasovanju.',
      introMailTitleTooLong:
        'E-mail adresa poziva za glasovanje ne može biti duža od 180 znakova.',
      reminderMailMissing:
        'Niste unijeli sadržaj e-pošte s podsjetnikom za glasovanje.',
      reminderMailTitleMissing:
        'Niste vnesli e-poštnega naslova za opomnik za glasovanje.',
      wrongCredentials: 'Vnesli ste napačne podatke o uporabniku.',
      noData: 'Ni podatkov',
      noResults: 'Ni rezultatov.',
      voterExists:
        'Volivec s tem e-poštnim naslovom ali mobilnim telefonom že obstaja.',
      failed: 'Neuspešno:',
      added: 'Dodano:',
      newOptionEnter: 'Pritisnite enter, da dodate novo možnost.',
      eventStatusFail:
        'Status je nevažeći. Samo statusi "Nacrt" i "Objavljeno" mogu se postaviti ručno.',
      eventSmsFail:
        'Obstaja oseba, katere telefonska številka ni bila vnesena.',
      leaveQuestion:
        'Ali ste prepričani, da želite zapustiti ta zaslon brez shranjevanja?',
      eventMissing: 'Dogodke je treba izbrati.',
      publishWarning:
        'Pred začetkom volitev preverite stanje čipov. Če nimate dovolj žetonov, ne morete začeti vprašanj.',
      publishQuestion: 'Ali ste prepričani, da želite objaviti dogodek?',
      passwordResetSuccess: 'Prosim, preglej svojo e-pošto.',
      passwordResetFail: 'Ni uporabnika s tem e-poštnim naslovom.',
      newPasswordMissing: 'Niste vnesli novega gesla',
      passwordMatch: 'Nova gesla se ne ujemajo.',
      passwordLength: 'Novo geslo mora biti dolgo vsaj 8 znakov.',
      newPasswordOldPasswordMatch: 'Novo in staro geslo se morata razlikovati.',
      passwordChangeSuccess: 'Vaše geslo se je spremenilo.',
      passwordChangeError: 'Vaše staro geslo je napačno.',
      timesWrong: 'Končni čas glasovanja mora biti po času začetka glasovanja.',
      automaticReminderWrong:
        'Število dni za samodejne opomnike mora biti krajše od trajanja dogodka.',
      automaticReminderZero: 'Število dni za samodejne opomnike ne sme biti 0.',
      noVoters: 'Za ta dogodek ni dodan noben volivec.',
      startTimeInThePast: 'Začetni čas ne more biti v preteklosti',
      maximumEmailsSent:
        'E-pošte ni mogoče poslati. Temu volivcu je bilo že poslano največje dovoljeno število e-poštnih sporočil.',
      logoutConfirmation: 'Ali ste prepričani, da se želite odjaviti?',
      userDisabled:
        'Vaš račun je bil zaklenjen, ker ste več kot 3-krat vnesli napačen PIN. Če želite odkleniti svoj račun, kliknite povezavo, poslano na vaš e-poštni naslov.',
      votersClearQuestion:
        'Ali ste prepričani, da želite odstraniti vse volivce?',
      invalidImport: 'Polja niso pravilno vnesena.',
      fileDeletionQuestion:
        'Ali ste prepričani, da želite odstraniti to datoteko?',
      nameSurnameMissing: 'Niste vpisali imena in priimka.',
      subjectMissing: 'Niste vnesli naslova.',
      messageMissing: 'Niste vnesli sporočila.',
      supportSuccess: 'Sporočilo poslano.',
      eventTooLong: 'Najdaljše trajanje dogodka je 1 mesec.',
      eventNoVoters: 'Za izbrane dogodke ni bil vpisan noben volivec',
      domainsError:
        'To spremembo ne morete izvesti na domenah, ker obstaja volivec ki se ne odziva na nove nastavitve.',
      voterDeactivationQuestion:
        'Ali ste prepričani, da želite deaktivirati uporabnika?',
      deactivationVoterVoted:
        'Volivca ni mogoče deaktivirati, ker je že glasoval.',
      excelNoVoters: 'Na seznamu ni volivcev.',
      testEmailsMissing: 'Niste vnesli nobenega naslova.',
      pinMatch: 'Niste vnesli pravilnih številk.',
      purchase: 'Vaše naročilo je v obdelavi. Kmalu vas bomo kontaktirali.',
      tokensNotAvailable:
        'Nimate na voljo dovolj žetonov. Za aktiviranje dodatnih žetonov se obrnite na info@fair-votes.com.',
      tfaPopup:
        'Predlagamo, da v nastavitvah omogočite dvofaktorsko preverjanje pristnosti za svoj račun.',
      savedPopup: 'Spremembe so shranjene.',
      emailVotedError:
        'Temu volivcu ne morete poslati opomnika, ker je glasoval.',
      pageRefreshed: 'Stran je osvežena',
      testSent: 'Povabila poslana.',
      invalidWeight: 'Teža ne sme biti 0.',
      removeEmailsFirst:
        'Preden izberete dovoljeno domeno, odstranite volivce.',
      tokenPurchaseRequestQuestion:
        'Ali ste prepričani, da želite poslati zahtevek?',
      clientExpired: "Your account has expired.",
    },
    buttons: {
      back: 'Nazaj',
      archive: 'Arhiv',
      clone: 'Podvojeno',
      preview: 'Predogled vstopnic',
      new: 'Novo',
      createNew: 'Ustvarite nove dogodke',
      save: 'Shrani',
      cancel: 'Razveljavi',
      yes: 'Da',
      no: 'Ne',
      ok: 'v redu',
      delete: 'Izbriši',
      edit: 'Uredi',
      addQuestion: 'Dodajte vprašanje',
      passwordSet: 'Nastavite geslo',
      passwordChange: 'Spremenite geslo',
      next: 'Nadalje',
      all: 'vse',
      completed: 'Zaključeni oziroma Končani dogodki',
      active: 'Aktivni',
      published: 'Objavljeno',
      drafts: 'Osnutki',
      editInfo:
        'Dodatne informacije o odgovoru bodo prikazane na glasovnici kot kratek opis z odgovorom',
      addVoter: 'Dodajte udeleženca',
      loadVoters: 'Uvoz udeležencev iz drugih dogodkov',
      importVoters: 'Uvoz udeležencev iz Excelove preglednice',
      downloadTemplate: 'Prenesite predlogo',
      downloadVoters: 'Prenesite seznam',
      resendEmail: 'Pošlji e-pošto volivcem, ki niso glasovali.',
      sendEmailVoter: 'Pošljite e-pošto volivcu',
      publish: 'Objavi',
      moveUp: 'Spremenite vrstni red vprašanj',
      moveDown: 'Spremenite vrstni red vprašanj',
      nextStep: 'Naslednji korak',
      loadLog: 'Naloži podatke',
      refreshLog: 'Osveži podatke',
      loadData: 'Uvoz iz drugih dogodkov',
      loadBallot: 'Uvozite glasovnico z drugih dogodkov',
      voterHistory: 'Pokaži volilno zgodovino tega volivca',
      sendSms: 'Pošlji SMS',
      send: 'pošlji',
      close: 'Zapri',
      saveDraft: 'Shrani kot predlogo ',
      deactivate: 'Deaktiviraj',
      test: 'Test',
      refresh: 'Osveži',
      pdf: 'PDF',
      buy: 'Kupite',
    },
    labels: {
      enableAudioVideo: 'Omogoči zvok/video',
      voterUiType: 'Način delovanja',
      voterUiTypeBasic: 'Osnovni',
      voterUiTypeAdvanced: 'Napredno',
      eventType: 'Vrsta izbire',
      anonymous: 'Anonimno',
      transparent: 'Transparentno',
      addOptionEnter: 'Dodajte z "Enter"',
      multiple_choices_enabled: 'Dovolite več odgovorov na to vprašanje',
      maximumChoices: 'Uporabite 0 za neomejeno.',
      noResultsEvents: 'Trenutno ni aktivnih dogodkov.',
      noResultsEventsDetails:
        'Sva obavezna polja su obavezna za najavu novog događaja. Kada događaji završe, možete ih deaktivirati ili izbrisati po potrebi. Izbrisani događaji više neće biti dostupni. Za detaljne upute o korištenju platforme FairVotes.LIVE kliknite na ""Pomoć"" na vrhu zaslona.',
      noResultsEventsFilter: 'V tej kategoriji ni dogodkov.',
      noResultsEventsSearch: 'Ni rezultatov iskanja.',
      singleAuthentication:
        'Preko e-naslova udeleženca - enostavna avtorizacija',
      doubleAuthentication:
        'Po e-poštnem naslovu udeleženca in številki mobilnega telefona udeleženca (SMS) - dvofaktorska avtorizacija',
      showResults: 'Pokaži rezultate glasovanja',
      eventLanguage: 'Jezik',
      results_in_progress_1:
        'Med glasovanjem ni vidno kako je posamezni udeleženec glasoval',
      results_in_progress_2:
        'Po koncu glasovanja je vidno kako je posamezni udeleženec glasoval',
      automatic_reminders_1:
        'Pošaljite podsjetnik e-poštom biračima koji nisu glasali za sve',
      automatic_reminders_2: ' dnevi',
      abstention: 'Dovolite udeležencem, da se vzdržijo tega vprašanja',
      manual_reminders:
        'Dovoli ročno pošiljanje e-pošte z vabilom na glasovanje med tekom glasovanja',
      adding_voters_in_progress: 'Dovoli dodajanje volivcev med dogodkom',
      alreadySent: 'Že poslano',
      smsSent: 'Glasovalcu je bilo poslano SMS sporočilo',
      unsubscribed: 'Ta volivec se je odjavil.',
      helpContactInfo: 'Podpora udeležencem za dogodek.',
      optionDescription: 'Opis odgovora',
      accountUpgrade: 'Nadgradite svoj <br/> račun',
      publishText:
        'Ko so vsa zahtevana polja izpolnjena, preverjena in potrjena s strani organizatorjev, kliknite na gumb "Objavi". Ko so dogodki objavljeni, jih ni mogoče urejati ali brisati do konca dogodka.',
      testText:
        'Ko so vsa zahtevana polja izpolnjena, preverjena in potrjena s strani organizatorjev, za izvedbo testa kliknite na gumb "Testiraj". <br/> Vabilo in povezavo do glasovnice boste prejeli po e-pošti (testiranje je možno v obliki preprostega pooblastila).',
      search: 'Išči po imenu ali oznaki',
      dropdownNoData: 'Trenutno ni podatkov.',
      editVoter: 'Uredite udeleženca',
      addVoter: 'Dodajte udeleženca',
      randomizeOptions: 'Naključna razvrstitev prikaza odziva udeležencev',
      identityConfirmation: 'Potrditev identitete udeleženca',
      editInfoTitle: 'Dodatne informacije o odzivu',
      mobileHint: '+385xxxxxxxxx ali 09xxxxxxxx',
      appLanguage: 'Izberi jezik aplikacije',
      changePassword: 'Spremeni geslo',
      emailRecieved: 'Prejeta pošta',
      emailOpened: 'Odprta pošta',
      linkClicked: 'Kliknuo na link',
      all: 'vse',
      supportTitle: 'Podpora',
      supportText: 'Vnesite svojo poizvedbo, prijavite težavo ali predlog.',
      uploadInProgress: 'Nalaganje je v teku.',
      attachmentPhoto: 'Priloga (fotografija)',
      licenseDetails: 'Podatki o licenci',
      unlockText:
        'Vaš račun je bil odklenjen. Prejeli boste novo geslo za prijavo na vaš e-poštni naslov.',
      answer: 'Odgovor',
      allowAllDomains: 'Dovoli vse domene',
      archive: 'Arhiv',
      voted: 'Glasoval',
      inactive: 'Neaktivan',
      domainExplanation:
        'Če želite dodati dovoljene domene, vnesite domeno in kliknite enter.',
      allow_unsubscriptions:
        'Dovoli volivcu, da se odjavi z glasovalnega seznama',
      eventTypeClassic: 'klasično glasovanje - 1 oseba = 1 glas',
      eventTypeWeighted:
        'ponderirano glasovanje – 1 oseba – odvisno od pomembnosti glasu udeleženca',
      testDialogTitle: 'Vnesite preizkusne naslove',
      deleteDialog:
        'Ali ste prepričani, da želite izbrisati ta volitvev? Glasovanje je trajno izbrisano in ga ni mogoče obnoviti. <br/>Če želite izbrisati, vnesite naslednje številke: <br/> <br/>',
      sendPdf:
        'Po glasovanju pošljete rezultate volivcem po elektronski pošti ',
      tokensTitle: 'Razpoložljivi žetoni',
      tokensPlayground: 'Na voljo e-vstopnice za igrišče:',
      tokensPro: 'Na voljo žetonov',
      tokens2fa: 'Na voljo 2fa žetonov',
      tokensExplanation:
        'Ko odprete račun, prejmete 50 brezplačnih žetonov za začetek glasovanja s preprosto avtorizacijo. 2-faktorska avtorizacija (SMS) pri brezplačnih žetonov ni mogoča.',
      tokensFormTitle: 'Kupite žetonov',
      piece: 'kos',
      emailBounce: 'E-pošte ni mogoče dostaviti',
      smsBounce: 'SMS ni mogoče dostaviti',
      tfa: 'Dvofaktorska avtorizacija',
      allowed_domains: 'Dovoljene domene',
      yes: 'Da',
      no: 'Ne',
      enable_live_questions: 'Vprašanja udeležencev v živo',
      live_questions_visibility: 'Vidljivost vprašanja',
      live_questions_visibility_organizer: 'Organizatorju',
      live_questions_visibility_organizer_and_voters:
        'Organizatorju in udeležencem',
      warmup_message: 'Vsebina, prikazana udeležencem pred začetkom volitev',
      technical_details_text:
        'Vsebina e-poštnih vabil udeležencem (tehnična navodila)',
      agenda: 'Napišite dnevni red svojega dogodka',
      logo_upload: 'Nalaganje logotipa',
      document_upload: 'Dodajte dokument',
      quorum: 'Kvorum',
      tokenExplanationGeneralTitle: 'Razlaga uporabe žetona',
      tokenExplanationGeneralPerEvent:
        'začetek volitev = žeton * (število volivcev/pooblaščencev)',
      tokenExplanationGeneralPerQuestion:
        'začetek vsakega vprašanja = žeton * (število volivcev/pooblaščencev)',
      tokenExplanationGeneral2fa:
        'Žetoni dvofaktorske avtentikacije so potrebni samo za sprožitev anket, ne pa za sprožitev vprašanj.',
      tokenExplanationAuthorizersTitle:
        'Dodatna razlaga uporabe žetonov za posrednike',
      tokenExplanationAuthorizersZero: 'volivec brez pooblaščenca = 1 žeton',
      tokenExplanationAuthorizersOne: 'volivec z 1 pooblaščencem = 1 žeton',
      tokenExplanationAuthorizersTwo: 'volivec z 2 pooblaščencema = 2 žetona',
      tokenExplanationAuthorizersN: 'volivec z n pooblaščenci = n žetonov',
    },
    importLabels: {
      totalRecords: '<b> Skupaj zapisov: </b>',
      importedRecords: '<b> Število uvoženih zapisov: </b>',
      emptyEmail: '<b> Število zapisov brez e-poštnega naslova: </b>',
      domainEmail: '<b> Število zapisov z nepooblaščeno domeno: </b>',
      failedEmail: '<b> Število zapisov z napačnimi e-poštnimi naslovi: </b>',
      failedMobile:
        '<b> Število zapisov z napačno številko mobilnega telefona: </b>',
      duplicates:
        '<b> Število podvojenih zapisov (e-pošta ali mobilni telefon): </b>',
    },
    languages: {
      en: 'Angleščina',
      hr: 'Hrvaščina',
      sl: 'Slovenščina',
    },
    ballot: {
      footer:
        'FairVotes.LIVE je sistem elektronskega glasovanja, ki ga je razvil IDE3 d.o.o. Vse pravice pridržane.',
      wrongTokenPreview: 'Pozdravljeni, zahtevana povezava ni aktivna.',
      wrongTokenVote:
        'Ta stran ni več aktivna. Vaš glas je že zabeležen ali pa se je glasovanje končalo.',
      previewAlert: 'To je le predogled glasovnice. Glasu ni mogoče posneti.',
      step1:
        'FairVotes.LIVE glasovanje:% title% <br/> Organizator:% client% <br/> Rok za glasovanje:% end% <br/> <br/> Spoštovani, <br/> <br/> pripravite svoj mobilni telefon za pooblastilo za glasovanje. <br/> <br/> PIN za avtorizacijo bo poslan v SMS-u na vaš mobilni telefon (registrirana številka se konča z <b> ***% phone_number% </b>). PIN za avtorizacijo je aktiven 2 uri od prejema. <br/> <br/> Za dodatna vprašanja se obrnite na skrbnika glasovanja na % help_contact%.',
      step2:
        'Pozdravljeni, <br/> <br/> Prosimo, vnesite PIN, ki ste ga prejeli prek SMS-a na vaš mobilni telefon (registrirana številka se konča z <b> ***% phone_number% </b>). <br/> <br / > Če sporočila niste prejeli, kliknite spodaj za ponovno pošiljanje.',
      btnAuthenticate: 'POOBLASTI SE',
      btnPinProblem: 'NISTE PREJELI SMS ALI JE PIN POTEK?',
      completed: 'Pozdravljeni, možnost glasovanja o tej temi je končana.',
      voteCasted: 'Pozdravljeni, vaš glas je zabeležen.',
      pinAlert:
        'Prevečkrat ste zahtevali žebljiček. Kontaktirajte organizatorja na',
      pinFail: 'PIN, ki ste ga vnesli, je napačna ali je potekla.',
      oneOption: 'izbrati je treba eno možnost',
      multipleOptionsA_1: 'je treba izbrati',
      multipleOptionsA_2: 'opcije',
      multipleOptionsB_1: 'je treba izbirati',
      multipleOptionsB_2: 'do',
      multipleOptionsB_3: 'opcije',
      abstent: 'Zadržan',
      btnVote: 'Glasujte',
      abstentionLock: 'Ne morete izbrati odgovora, če ste zadržani.',
      wrongNumberOfOptions: 'Neveljavno število izbranih možnosti.',
      unsubscribeSuccess: 'Uspešno ste bili odjavljeni.',
      unsubscribeQuestion:
        'Ali ste prepričani, da se želite odjaviti s spletnega volilnega seznama',
      expired: 'Ne morete glasovati, ker je glasovanje končano.',
      wrongSession:
        'Povezava za glasovanje je že odprta na drugi napravi. Prosimo, zaprite prej odprto povezavo ali ponovno odprite povezavo za glasovanje čez 5 minut.',
    },
    statuses: {
      draft: 'Osnutek',
      published: 'Objavljeno',
      active: 'Aktivno',
      completed: 'Končano',
      archive: 'Arhivi',
    },
    filters: {
      active: 'Aktivno',
      sms: 'SMS',
      status: 'Stanje',
      helpFilter: 'Filter pomoči',
      help: 'Help',
      active1: 'Aktivno',
      active0: 'Deaktivirano',
      sms0: '0 zahtevanih PIN-kod',
      sms1: '1 zahtevana koda PIN',
      sms2: '2 zahtevana PIN-ja',
      sms3: '3 zahtevane kode PIN ',
      sms4: 'več kot 3 zahtevane kode PIN',
      emailSent1: 'E-pošta poslana',
      emailSent0: 'E-pošta ni poslana',
      emailReceived1: 'Prejeto e-sporočilo',
      emailReceived0: 'Nisem prejel e-pošte',
      emailOpened1: 'Odprta e-pošta',
      emailOpened0: 'E-pošta ni odprta',
      linkOpened1: 'Povezava za glasovanje je odprta',
      linkOpened0: 'Povezava za glasovanje ni odprta',
      pinRequested1: 'Zahtevana PIN koda',
      pinRequested0: 'PIN ni zahtevan',
      pinReceived1: 'Prejeta PIN koda ',
      pinReceived0: 'Niste dobili PIN',
      voted1: 'Glasoval',
      voted0: 'Ni glasoval',
      voterOnline1: 'Prisoten udeleženec',
      voterOnline0: 'Udeleženec ni prisoten',
    },
    tooltips: {
      downloadEventPdf: 'Prenesi rezultate v PDF obliki',
      newEvent: 'Ustvari nov dogodek',
      loadBallot:
        'Izpolnite polja glave, naslove, noge in vprašanja z drugih dogodkov',
      addQuestion: 'Dodaj vprašanje za listek',
      addVoter: 'Dodaj udeleženca na seznam za glasovanje',
      loadVoters: 'Uvoz udeležencev iz drugega dogodka ',
      importVoters: 'Uvoz udeležencev iz excelove preglednice',
      downloadTemplate:
        'Prenesite Excelovo predlogo za uvoz seznama udeležencev',
      downloadVoters: 'Prenos tabele volivcev',
      loadEmailData:
        'Izpolnite polja e-poštni naslov, besedilo in e-poštni naslov s podatki iz drugih dogodkov',
      publish: 'Najavite glasovanje',
      back: 'Nazaj na seznam dogodkov',
      save: 'Shranite dogodek',
      nextStep: 'Naslednji korak ',
      edit: 'Uredi izbrani dogodek',
      preview: 'Predogled postavitve glasovnice na zaslonu',
      clone: 'Podvoji oziroma kopiraj',
      delete: 'Izbriši izbrani dogodek',
      archive: 'Premakni izbrani dogodek v arhiv',
      clearVoters: 'Počisti seznam volivcev',
      resultsInProgress:
        'Priporočamo uporabo opcije "Po glasovanju" za prikaz rezultatov, zaradi preglednosti in za odpravo možnosti vplivanja na volivce na podlagi trenutnih rezultatov',
      saveDraft: 'Shrani kot predlogo ',
      test: 'Test',
      audioVideoTooltip:
        'Za promjenu Audio/Video opcije kontaktirajte svog administratora',
      questionAnonymity:
        'Ukoliko se ne odabere, anonimnost pitanja ovisit će o postavkama izbora',
    },
  }
}
